<template>
    <el-dialog :title="title" :fullscreen="fullscreen" v-model="internalDialogVisible" :max-width="maxWidth">
        <slot></slot>
        <div v-if="hasSaveListener" class="d-flex justify-between">
            <el-button color="error" variant="tonal" @click="closeDialog">Close</el-button>
            <el-button variant="tonal" @click="saveData" color="green">Save</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: 'CustomDialog',
        props: {
            modelValue: {
                type: Boolean,
                required: true,
            },
            title: {
                type: String,
                default: 'Dialog Title',
            },
            icon: {
                type: String,
                default: 'fa-list-ul',
            },
            maxWidth: {
                type: String,
                default: '800',
            },
            fullscreen: false,
        },
        data() {
            return {
                actionButton: false,
            }
        },
        computed: {
            internalDialogVisible: {
                get() {
                    return this.modelValue
                },
                set(value) {
                    this.$emit('update:modelValue', value)
                },
            },
            hasSaveListener() {
                return !!this.$attrs['onSave']
            },
        },
        methods: {
            closeDialog() {
                this.internalDialogVisible = false
            },
            saveData() {
                var valid = this.$refs.myForm.validate()
                if (!valid) {
                    return
                }
                this.$emit('save', 'Data saved!')
            },
        },
    }
</script>
